// src/components/HomeActionButton/HomeActionButton.jsx
import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import TagManager from 'react-gtm-module';
import styles from './HomeActionButton.module.scss';

// Creamos un componente motion sobre el Link de react‑router
const MotionLink = motion(Link);

const HomeActionButton = () => {

  const handleClick = () => {
    if (typeof window !== 'undefined') {
      TagManager.dataLayer({
        dataLayer: {
          event: 'ux_event',
          event_name: 'home_hero_ver_maquinaria',
          event_category: null,
          event_label: null,
          value: null,
          slug: null
        }
      });
    }
  };

  return (
    <MotionLink
      to="/productos"
      className={styles.container}
      onClick={handleClick}
      whileHover={{
        scale: 1.05,
        y: -3,
        boxShadow: '0px 4px 15px rgba(0, 0, 0, 0.2)',
      }}
      transition={{
        type: 'spring',
        stiffness: 300,
        damping: 20
      }}
    >
      <span className={styles.content}>
        VER MAQUINARIA
      </span>
    </MotionLink>
  );
};

export default HomeActionButton;
